<template>
    <div class="row mb-4">
        <div class="col-md-3 mb-4">
            <label class="form-label" for="command">Command</label>
            <select id="command" class="form-select" v-model="filters.command">
                <option value="">All</option>
                <option v-for="command in commands" :key="command.value" :value="command.value">{{ command.label }}</option>
            </select>
        </div>
        <div class="col-md-3 mb-4">
            <label class="form-label" for="start_date">Date</label>
            <input id="start_date" type="date" class="form-control" v-model="filters.start_date" />
        </div>
    </div>
    <div class="row mb-4">
        <div class="col-md-2">
            <select class="form-select" v-model="limit">
                <option>25</option>
                <option>50</option>
                <option>100</option>
            </select>
        </div>
    </div>

    <datatable :url="ajaxUrl" :limit="limit" :orderBy="orderBy" :orderAsc="orderAsc" :search="searchTerm" :filters="filters">
        <template #headings>
            <sortableTh v-on:set-order-by="setOrder" :currentOrderBy="orderBy" :orderAsc="orderAsc" orderBy="id">ID</sortableTh>
            <sortableTh v-on:set-order-by="setOrder" :currentOrderBy="orderBy" :orderAsc="orderAsc" orderBy="created_at">Created At</sortableTh>
            <th>User</th>
            <th>Command</th>
            <sortableTh v-on:set-order-by="setOrder" :currentOrderBy="orderBy" :orderAsc="orderAsc" orderBy="start_date">Start Date</sortableTh>
            <th>Status</th>
            <sortableTh v-on:set-order-by="setOrder" :currentOrderBy="orderBy" :orderAsc="orderAsc" orderBy="completed_at">Completed At</sortableTh>
        </template>
        <template #rows="{data}">
            <tr v-for="row in data" :key="row.id">
                <td>{{ row.id }}</td>
                <td>{{ row.created_at }}</td>
                <td>{{ row.user_name }}</td>
                <td>{{ row.command }}</td>
                <td>{{ row.start_date }}</td>
                <td>
                    <span class="badge" :class="statusClass(row.status)">
                        {{ row.status }}
                    </span>
                </td>
                <td>{{ row.completed_at ?? '-' }}</td>
            </tr>
        </template>
    </datatable>
</template>

<script setup>
import datatable from '@/components/datatable.vue';
import sortableTh from '@/components/datatable/sortableTh.vue';
import { reactive, ref } from "vue";

defineProps({
    ajaxUrl: String,
    commands: Array,
});

const orderBy = ref('created_at');
const orderAsc = ref(false);
const limit = ref(25);
const searchTerm = ref(null);
const filters = reactive({
    command: '',
    start_date: '',
});

const setOrder = function (input) {
    if (orderBy.value == input) {
        orderAsc.value = ! orderAsc.value;
    } else {
        orderBy.value = input;
        orderAsc.value = true;
    }
};

const statusClass = function (status) {
    // add text-dark if you need to but you probably don't

    return {
        Completed: 'bg-success',
        Failed: 'bg-danger',
        Processing: 'bg-warning',
        Pending: 'bg-secondary',
    }[status] ?? 'bg-secondary';
};
</script>
